const ROUNDED = '400';
const SQUARE = '0';

/* Mobile cards sit flush against each other, so only the strip's two outer
 * ends stay rounded; corners touching a neighbor go square. */
export const getHsocMerchCardCornerRadius = (isFirstCard, isLastCard, isMd) => {
  if (isMd || isFirstCard && isLastCard) {
    return {
      borderStartStartRadius: ROUNDED,
      borderStartEndRadius: ROUNDED,
      borderEndStartRadius: ROUNDED,
      borderEndEndRadius: ROUNDED
    };
  }
  return {
    borderStartStartRadius: isFirstCard ? ROUNDED : SQUARE,
    borderEndStartRadius: isFirstCard ? ROUNDED : SQUARE,
    borderStartEndRadius: isLastCard ? ROUNDED : SQUARE,
    borderEndEndRadius: isLastCard ? ROUNDED : SQUARE
  };
};